module.exports = __webpack_public_path__ + "img/team-8.87195e12.png";